import React, { createContext, useState, useEffect, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    const storedToken = localStorage.getItem("token_royal");
    if (storedToken) {
      setToken(storedToken);

      setUser(storedToken);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (isLoggedOut) {
      // Redirigir después de cerrar sesión
      window.location.href = "/#/auth/signin";
      console.log("AUQI ESTO");
    }
  }, [isLoggedOut]);

  const login = async (username, password) => {
    // Simulación de una llamada a la API
    localStorage.setItem("token_royal", "William");
    setUser("William");
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token_royal");
    setIsLoggedOut(true);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
